import {
  Habit,
  RepeatingTask,
  ScheduleEntryState,
  Timestamp,
} from '@griply/types';
import { isSameDay } from 'date-fns';

import { getScheduleByDate } from './get-schedule-by-date';

export const getScheduleEntryStateForDate = (
  habit: Habit | RepeatingTask,
  date: Timestamp,
  today: Timestamp,
): ScheduleEntryState | undefined => {
  const schedule = getScheduleByDate(habit.schedules, { date, today });
  const entry = schedule?.entries.find((scheduleEntry) =>
    isSameDay(scheduleEntry.date, date),
  );
  return entry?.state;
};
